<template>
    <ac-modal :title="'Provider Search Link'" ref="modalRef">
        <template>
            <div class="row">
                <div class="col-xs-12">
                    <div class="input-group">
                        <input type="text" class="form-control" ref="linkUrl" v-model="url" readonly>
                        <span class="input-group-btn">
                                <ac-button class="btn btn-green provider-search-link-button" :action="copy">
                                    Copy
                                </ac-button>
                            </span>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";

    export default {
        name: "ViewLinkModal",
        data() {
            return {
                url: ""
            };
        },
        methods: {
            async showModal({companyId, linkId}) {
                let data = await api.getDataWithTwoIds('EnrollmentLink', companyId, 'GetLinkUrl', linkId);
                this.url = data;
                this.$refs.modalRef.open();
            },
            copy() {
                this.$refs.linkUrl.select();
                document.execCommand('copy');
            }
        }
    }
</script>

<style scoped>

</style>